import { CHeader, CToggler } from "@coreui/react";

import { GlobalQueryLoader, NavbarMenu, ViewAsIcon } from "components";
import TheHeaderLogic from "./Header.logic";
import CareHomeSwitcher from "pages/SubAdmins/UI/CareHomeSwitcher";
import { useSelector } from "react-redux";
import CIcon from "@coreui/icons-react";
import { cilUser } from "@coreui/icons";

import "./Header.scss";

const TheHeader = () => {
  const { userName, dayStatus, onTogglerClick } = TheHeaderLogic();
 const authData = useSelector(
  (state) => state.auth.user
);
console.log("AUTH DATA", authData);
const subAdmin = JSON.parse(
  localStorage.getItem("subAdmin") || "{}"
);
  return (
    <CHeader className="header">
      <div className="left-side">
        {/* Sidebar toggler */}
        <CToggler
          inHeader
          className="ml-md-3 d-lg-none"
          onClick={onTogglerClick}
        />
        <div className="d-none d-sm-block ml-0 ml-lg-4">
          {/* Greeting */}
          <span className="greet">
            <span>{`Good ${dayStatus}${userName ? ", " : "!"} `}</span>
            {userName && <b> {userName}</b>}
          </span>
        </div>
      </div>

      <div className="right-side">
        {localStorage.getItem("isSubAdminContext") === "true" && (
          <>
            <div
              className="d-flex align-items-center btn btn-light mr-3"
              style={{
                borderRadius: "20px",
                padding: "4px 12px",
                color: "#4f5d73",
                fontWeight: 600,
                cursor: "default",
                border: "1px solid #d8dbe0",
              }}
            >
              <CIcon
                content={cilUser}
                className="mr-2"
              />
              {subAdmin?.name}
            </div>

            <CareHomeSwitcher />
          </>
        )}
        {/* Shows loader when a query is active */}
        <GlobalQueryLoader />
        {/* For super admin to remind if is using viewAs feature */}
        <ViewAsIcon />
        <NavbarMenu />
      </div>
    </CHeader>
  );
};

export default TheHeader;
